export const COOKIES_KEYS = { authToken: 'sessionid_2' as const };
